import { useAuth } from '@/context/AuthContext';
import { useLeftSidebar } from '@/hooks/useLeftSidebar';
import { PanelLeft } from 'lucide-react';
import { useRouter } from 'next/router';
import { Button } from './Button/Button';
import { Icon } from './ui/Icon';

const Navbar = () => {
  const router = useRouter();
  const { showLeftSidebar, setShowLeftSidebar } = useLeftSidebar();
  const { userPlanDetails, user } = useAuth();

  // const isNew = router.pathname.startsWith('/new');

  const handleLoginClick = () => {
    router.push('/login');
  };

  const handleSignupClick = () => {
    router.push('/login');
  };

  const isNew = router.pathname.startsWith('/new');

  return (
    <div className="sticky top-0 z-10 pl-3 pr-2 py-2 h-[45px] flex-shrink-0  w-full flex flex-row justify-between items-center border-b border-borderSecondary bg-background">
      <div className="flex items-center gap-2">
        {!showLeftSidebar && (
          <Button
            size="icon"
            variant="ghost"
            onClick={() => {
              setShowLeftSidebar(true);
            }}
          >
            <Icon as={PanelLeft} />
          </Button>
        )}
        {isNew && (
          <p className="text-sm px-1.5 lg:max-w-2xl md:max-w-md truncate w-full">
            Home
          </p>
        )}
      </div>
      <div className="flex flex-row items-center gap-3 ml-auto">
        {user && userPlanDetails?.planName === 'Free' && (
          <Button
            size="xs"
            onClick={() => {
              router.push('/pricing');
            }}
          >
            Upgrade
          </Button>
        )}

        {!user && (
          <Button size="xs" variant="secondary" onClick={handleLoginClick}>
            Log in
          </Button>
        )}

        {!user && (
          <Button size="xs" onClick={handleSignupClick}>
            Sign up
          </Button>
        )}
      </div>
    </div>
  );
};

export default Navbar;
